import React from 'react';

const ProgressBar = ({ percentage = 0, step = '', className = '' }) => {
  return (
    <div className={`progress-container ${className}`}>
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
        />
      </div>
      {step && <p className="progress-text">{step}</p>}
    </div>
  );
};

export default ProgressBar;
